import { Checkbox } from "../UI/Checkbox";
import type { CheckboxProps } from "../UI/Checkbox";

export function getControllerCheckboxRender(props: CheckboxProps) {
  // eslint-disable-next-line react/display-name
  return ({ field }: any) => (
    <Checkbox {...field} {...props} isChecked={field.value} onChange={(e: any) => field.onChange(e.target.checked)} />
  );
}
